@if (media && media.src) {
  <img
    [style.width]="width"
    [attr.src]="media.src"
    [attr.srcset]="media.srcset"
    [attr.alt]="media.alt"
    [attr.role]="media.role"
    [attr.sizes]="sizes"
    [attr.loading]="loading"
    [attr.fetchpriority]="fetchPriority"
    (load)="loadHandler()"
    (error)="errorHandler()"
  />
}
